import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS, CommonParams } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetChats = (
  params?: CommonParams<{ status?: string; pic?: number }>
) => {
  const { data, isLoading, error, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [CHAT_QUERY_KEYS.ALL_CHATS, params, params],
      queryFn: ({ pageParam }) =>
        ChatService.getChats({
          ...params,
          page: pageParam,
          title: params?.search,
        }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => {
        return lastPage.pagination?.hasNextPage
          ? lastPage.pagination.page + 1
          : undefined;
      },
      retry: 1,
    });

  const chatRooms = useMemo(() => {
    return data?.pages.flatMap((page) => page.data) || [];
  }, [data]);

  // throw error to be caught by error boundary
  if (error) throw error;

  return {
    chatRooms,
    isLoading,
    error,
    isFetching,
    hasNextPage,
    fetchNextPage,
  };
};
